import {RefObject, useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import {FormattedMessage} from "react-intl";

import * as S from './styles'

import Phone1 from '../../../assets/images/m_cnt2_phone1.png';
import Phone2 from '../../../assets/images/m_cnt2_phone2.png';
import Phone3 from '../../../assets/images/m_cnt2_phone3.png';
import Phone4 from '../../../assets/images/m_cnt2_phone4.png';
import Phone5 from '../../../assets/images/m_cnt2_phone5.png';
import Phone6 from '../../../assets/images/m_cnt2_phone6.png';

type IntersectProps = {
    ref1: RefObject<HTMLDivElement>
    ref2: RefObject<HTMLDivElement>
    ref3: RefObject<HTMLDivElement>
    setImagePath: Function
}

const useIntersects = ({ref1, ref2, ref3, setImagePath}: IntersectProps) => {
    useEffect(() => {
        const target1 = ref1.current as HTMLDivElement;
        const target2 = ref2.current as HTMLDivElement;
        const target3 = ref3.current as HTMLDivElement;

        let key1, key2, key3;

        const options = {
            threshold: 1
        }

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.target === target1) {
                        setImagePath(Phone2);
                        key1 = setTimeout(() => setImagePath(Phone3), 1000);
                    } else if (entry.target === target2) {
                        clearTimeout(key1);
                        setImagePath(Phone4);
                        key2 = setTimeout(() => setImagePath(Phone5), 1000);
                        key3 = setTimeout(() => {setImagePath(Phone6); clearTimeout(key2)}, 2000);
                    } else if (entry.target === target3) {
                        clearTimeout(key3);
                        setImagePath(Phone1);
                    }
                }
            })
        }, options);

        observer.observe(target1)
        observer.observe(target2)
        observer.observe(target3)

        return () => {
            observer.unobserve(target1);
            observer.unobserve(target2);
            observer.unobserve(target3);
        }
    }, []);
}

export const Content2 = observer(() => {

    const [imagePath, setPath] = useState(Phone1);
    const [visibleText1, showText1] = useState(false)
    const [visibleText2, showText2] = useState(false)
    const [visibleText3, showText3] = useState(false)

    const [isMobile, setMobile] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const text1Ref = useRef<HTMLDivElement>(null);
    const text2Ref = useRef<HTMLDivElement>(null);
    const text3Ref = useRef<HTMLDivElement>(null);
    const text4Ref = useRef<HTMLDivElement>(null);
    const text5Ref = useRef<HTMLDivElement>(null);
    const text6Ref = useRef<HTMLDivElement>(null);

    useIntersects({ref1: text2Ref, ref2: text3Ref, ref3: text5Ref, setImagePath: setPath})

    useEffect(() => {
        const width = containerRef?.current?.getBoundingClientRect().width || 0;
        setMobile(width < 993);
    }, []);

    const content = isMobile
        ?
        (
            <S.MobileContent>
                <S.Phone src={imagePath}/>
            </S.MobileContent>
        )
        :
        (
            <S.Content>
                <div>
                    <S.Line1>
                        <S.LeftText ref={text1Ref}>
                            <span><FormattedMessage id="phoneText1"/></span>
                        </S.LeftText>
                    </S.Line1>
                    <S.Line3>
                        <S.LeftText ref={text3Ref}>
                            <span><FormattedMessage id="phoneText3"/></span>
                        </S.LeftText>
                    </S.Line3>
                    <S.Line5>
                        <S.LeftText ref={text5Ref}>
                            <span><FormattedMessage id="phoneText5"/></span>
                        </S.LeftText>
                    </S.Line5>
                </div>
                <S.Phone src={imagePath}/>
                <div>
                    <S.Line2>
                        <S.RightText ref={text2Ref}>
                            <span><FormattedMessage id="phoneText2"/></span>
                        </S.RightText>
                    </S.Line2>
                    <S.Line4>
                        <S.RightText ref={text4Ref}>
                            <span><FormattedMessage id="phoneText4"/></span>
                        </S.RightText>
                    </S.Line4>
                    <S.Line6>
                        <S.RightText ref={text6Ref}>
                            <span><FormattedMessage id="phoneText6"/></span>
                        </S.RightText>
                    </S.Line6>
                </div>
            </S.Content>
        );

    return (
        <S.Container ref={containerRef}>
            {content}
        </S.Container>
    )
})
